export default "__VITE_ASSET__BcV$LB9O__"